// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-header {
  display: none;
}

@media (max-width: 992px) {
  app-header-desktop {
    display: none;
  }
}

.row-block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3px 20px;
}
.row-block .logo-icon {
  height: 51px;
  width: 110px;
}
@media (min-width: 991px) {
  .row-block .logo-icon {
    height: 57px;
    width: 157px;
    padding: 10px;
  }
}
.row-block .home-click {
  cursor: pointer;
}
.row-block .width-20 {
  width: 25%;
  text-align: left;
}
.row-block .width-20:last-child {
  text-align: right;
}

#map {
  width: 100%;
  height: 100%;
}

.search-bar {
  border-radius: 4px;
  line-height: 1.6;
}

.search-bar > div {
  height: 100%;
  display: flex;
  flex-direction: row;
  place-items: center;
}

#search-container {
  top: 4px;
  left: 4px;
  right: 4px;
  position: absolute;
  padding: 4px;
}
#search-container app-venue-suggestion {
  width: 100%;
}

.slides-container {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
}

.swiper-slide {
  align-self: flex-end;
}

app-venue-suggestion {
  width: 90%;
}

.mode-icon {
  padding: 6px;
  height: 23px;
  width: 23px;
  border-radius: 1px;
}

.mode-icon {
  background: white;
  color: var(--ion-color-black);
  transition: 0.3s linear;
}

.mode-icon.selected {
  background: var(--ion-color-primary);
  color: white;
  transition: 0.3s linear;
}

.full-height {
  height: 100%;
}

.sidebar {
  overflow: auto;
  height: 100%;
}
.sidebar app-venue-suggestion {
  margin: 5px auto;
}
.sidebar .title {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}

.loading-container {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
  background: black;
  opacity: 0.5;
}

.hint {
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 14px;
  background: white;
}
.hint p {
  font-size: 12px;
  color: black;
  margin: 0;
  padding: 0 8px;
}
.hint span {
  font-size: 14px;
}
.hint ion-icon {
  height: 44px;
  width: 44px;
  place-self: center;
}

ion-header {
  box-shadow: none;
}
ion-header .toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 75px;
  padding: 0px 20px;
}
ion-header .toolbar ion-img {
  width: 180px;
}
ion-header .toolbar .right-block {
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/map/map.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EAEI,aAAA;AAFJ;;ACKE;EDCF;IAEI,aAAA;EAHF;AACF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;AAHF;AAIE;EACE,YAAA;EACA,YAAA;AAFJ;AClBE;EDkBA;IAII,YAAA;IACA,YAAA;IACA,aAAA;EAAJ;AACF;AAEE;EACE,eAAA;AAAJ;AAGE;EACE,UAAA;EACA,gBAAA;AADJ;AAGE;EACE,iBAAA;AADJ;;AAIA;EACE,WAAA;EACA,YAAA;AADF;;AAIA;EACE,kBAAA;EACA,gBAAA;AADF;;AAIA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AADF;;AAIA;EACE,QAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;AADF;AAGE;EACE,WAAA;AADJ;;AAKA;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;AAFF;;AAKA;EACE,oBAAA;AAFF;;AAKA;EACE,UAAA;AAFF;;AAKA;EACE,YAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AAFF;;AAKA;EACE,iBAAA;EACA,6BAAA;EACA,uBAAA;AAFF;;AAKA;EACE,oCAAA;EACA,YAAA;EACA,uBAAA;AAFF;;AAKA;EACE,YAAA;AAFF;;AAKA;EAKE,cAAA;EACA,YAAA;AANF;AACE;EACE,gBAAA;AACJ;AAKE;EACE,UAAA;EACA,iBAAA;EACA,kBAAA;AAHJ;;AAOA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;AAJF;;AAOA;EACE,wCAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;AAJF;AAME;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;AAJJ;AAOE;EACE,eAAA;AALJ;AAQE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AANJ;;AAUA;EAEE,gBAAA;AARF;AAUE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AARJ;AASI;EACE,YAAA;AAPN;AASI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAPN","sourcesContent":["@import \"../../../theme/mixins\";\n\napp-header {\n  // @include desktop {\n    display: none;\n  // }\n}\n\napp-header-desktop {\n  @include mobile {\n    display: none;\n  }\n}\n\n.row-block {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 3px 20px;\n  .logo-icon {\n    height: 51px;\n    width:110px;\n    @include desktop {\n      height: 57px;\n      width: 157px;\n      padding: 10px;\n    }\n  }\n  .home-click {\n    cursor: pointer;\n  }\n\n  .width-20 {\n    width: 25%;\n    text-align: left;\n  }\n  .width-20:last-child {\n    text-align: right;\n  }\n}\n#map {\n  width: 100%;\n  height: 100%;\n}\n\n.search-bar {\n  border-radius: 4px;\n  line-height: 1.6;\n}\n\n.search-bar > div {\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  place-items: center;\n}\n\n#search-container {\n  top: 4px;\n  left: 4px;\n  right: 4px;\n  position: absolute;\n  padding: 4px;\n\n  app-venue-suggestion {\n    width: 100%;\n  }\n}\n\n.slides-container {\n  position: absolute;\n  bottom: 20px;\n  left: 0;\n  right: 0;\n}\n\n.swiper-slide {\n  align-self: flex-end;\n}\n\napp-venue-suggestion {\n  width: 90%;\n}\n\n.mode-icon {\n  padding: 6px;\n  height: 23px;\n  width: 23px;\n  border-radius: 1px;\n}\n\n.mode-icon {\n  background: white;\n  color: var(--ion-color-black);\n  transition: 0.3s linear;\n}\n\n.mode-icon.selected {\n  background: var(--ion-color-primary);\n  color: white;\n  transition: 0.3s linear;\n}\n\n.full-height {\n  height: 100%;\n}\n\n.sidebar {\n  app-venue-suggestion {\n    margin: 5px auto;\n  }\n\n  overflow: auto;\n  height: 100%;\n\n  .title {\n    width: 90%;\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n\n.loading-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 10;\n  background: black;\n  opacity: 0.5;\n}\n\n.hint {\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  padding: 14px;\n  background: white;\n\n  p {\n    font-size: 12px;\n    color: black;\n    margin: 0;\n    padding: 0 8px;\n  }\n\n  span {\n    font-size: 14px;\n  }\n\n  ion-icon {\n    height: 44px;\n    width: 44px;\n    place-self: center;\n  }\n}\n\nion-header {\n  // background:var(--ion-color-secondary) center bottom/105% no-repeat !important;\n  box-shadow: none;\n\n  .toolbar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    min-height: 75px;\n    padding: 0px 20px;\n    ion-img {\n      width: 180px;\n    }\n    .right-block {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
